//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.8.0 (NJsonSchema v11.0.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import BaseClient from './BaseClient';import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export interface IDeliveryApiClient {
    /**
     * @param fetch (optional) Specifies the content items to fetch. Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api#query-parameters) for more details on this.
     * @param filter (optional) Defines how to filter the fetched content items. Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api#query-parameters) for more details on this.
     * @param sort (optional) Defines how to sort the found content items. Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api#query-parameters) for more details on this.
     * @param skip (optional) Specifies the number of found content items to skip. Use this to control pagination of the response.
     * @param take (optional) Specifies the number of found content items to take. Use this to control pagination of the response.
     * @param expand (optional) Defines the properties that should be expanded in the response. Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api#query-parameters) for more details on this.
     * @param accept_Language (optional) Defines the language to return. Use this when querying language variant content items.
     * @param api_Key (optional) API key specified through configuration to authorize access to the API.
     * @param preview (optional) Whether to request draft content.
     * @param start_Item (optional) URL segment or GUID of a root content item.
     * @return OK
     * @deprecated
     */
    getContent(fetch?: string | undefined, filter?: string[] | undefined, sort?: string[] | undefined, skip?: number | undefined, take?: number | undefined, expand?: string | undefined, accept_Language?: string | undefined, api_Key?: string | undefined, preview?: boolean | undefined, start_Item?: string | undefined): Promise<PagedIApiContentResponseModel>;
    /**
     * @param fetch (optional) Specifies the content items to fetch. Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api#query-parameters) for more details on this.
     * @param filter (optional) Defines how to filter the fetched content items. Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api#query-parameters) for more details on this.
     * @param sort (optional) Defines how to sort the found content items. Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api#query-parameters) for more details on this.
     * @param skip (optional) Specifies the number of found content items to skip. Use this to control pagination of the response.
     * @param take (optional) Specifies the number of found content items to take. Use this to control pagination of the response.
     * @param expand (optional) Defines the properties that should be expanded in the response. Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api#query-parameters) for more details on this.
     * @param fields (optional) Explicitly defines which properties should be included in the response (by default all properties are included). Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api#query-parameters) for more details on this.
     * @param accept_Language (optional) Defines the language to return. Use this when querying language variant content items.
     * @param api_Key (optional) API key specified through configuration to authorize access to the API.
     * @param preview (optional) Whether to request draft content.
     * @param start_Item (optional) URL segment or GUID of a root content item.
     * @return OK
     */
    getContent2_0(fetch?: string | undefined, filter?: string[] | undefined, sort?: string[] | undefined, skip?: number | undefined, take?: number | undefined, expand?: string | undefined, fields?: string | undefined, accept_Language?: string | undefined, api_Key?: string | undefined, preview?: boolean | undefined, start_Item?: string | undefined): Promise<PagedIApiContentResponseModel>;
    /**
     * @param id (optional) 
     * @param expand (optional) Defines the properties that should be expanded in the response. Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api#query-parameters) for more details on this.
     * @param accept_Language (optional) Defines the language to return. Use this when querying language variant content items.
     * @param api_Key (optional) API key specified through configuration to authorize access to the API.
     * @param preview (optional) Whether to request draft content.
     * @param start_Item (optional) URL segment or GUID of a root content item.
     * @return OK
     * @deprecated
     */
    getContentItem(id?: string[] | undefined, expand?: string | undefined, accept_Language?: string | undefined, api_Key?: string | undefined, preview?: boolean | undefined, start_Item?: string | undefined): Promise<IApiContentResponseModel[]>;
    /**
     * @param expand (optional) Defines the properties that should be expanded in the response. Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api#query-parameters) for more details on this.
     * @param accept_Language (optional) Defines the language to return. Use this when querying language variant content items.
     * @param api_Key (optional) API key specified through configuration to authorize access to the API.
     * @param preview (optional) Whether to request draft content.
     * @param start_Item (optional) URL segment or GUID of a root content item.
     * @return OK
     * @deprecated
     */
    getContentItemByPath(path: string, expand?: string | undefined, accept_Language?: string | undefined, api_Key?: string | undefined, preview?: boolean | undefined, start_Item?: string | undefined): Promise<IApiContentResponseModel>;
    /**
     * @param expand (optional) Defines the properties that should be expanded in the response. Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api#query-parameters) for more details on this.
     * @param fields (optional) Explicitly defines which properties should be included in the response (by default all properties are included). Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api#query-parameters) for more details on this.
     * @param accept_Language (optional) Defines the language to return. Use this when querying language variant content items.
     * @param api_Key (optional) API key specified through configuration to authorize access to the API.
     * @param preview (optional) Whether to request draft content.
     * @param start_Item (optional) URL segment or GUID of a root content item.
     * @return OK
     */
    getContentItemByPath2_0(path: string, expand?: string | undefined, fields?: string | undefined, accept_Language?: string | undefined, api_Key?: string | undefined, preview?: boolean | undefined, start_Item?: string | undefined): Promise<IApiContentResponseModel>;
    /**
     * @param expand (optional) Defines the properties that should be expanded in the response. Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api#query-parameters) for more details on this.
     * @param accept_Language (optional) Defines the language to return. Use this when querying language variant content items.
     * @param api_Key (optional) API key specified through configuration to authorize access to the API.
     * @param preview (optional) Whether to request draft content.
     * @param start_Item (optional) URL segment or GUID of a root content item.
     * @return OK
     * @deprecated
     */
    getContentItemById(id: string, expand?: string | undefined, accept_Language?: string | undefined, api_Key?: string | undefined, preview?: boolean | undefined, start_Item?: string | undefined): Promise<IApiContentResponseModel>;
    /**
     * @param expand (optional) Defines the properties that should be expanded in the response. Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api#query-parameters) for more details on this.
     * @param fields (optional) Explicitly defines which properties should be included in the response (by default all properties are included). Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api#query-parameters) for more details on this.
     * @param accept_Language (optional) Defines the language to return. Use this when querying language variant content items.
     * @param api_Key (optional) API key specified through configuration to authorize access to the API.
     * @param preview (optional) Whether to request draft content.
     * @param start_Item (optional) URL segment or GUID of a root content item.
     * @return OK
     */
    getContentItemById2_0(id: string, expand?: string | undefined, fields?: string | undefined, accept_Language?: string | undefined, api_Key?: string | undefined, preview?: boolean | undefined, start_Item?: string | undefined): Promise<IApiContentResponseModel>;
    /**
     * @param id (optional) 
     * @param expand (optional) Defines the properties that should be expanded in the response. Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api#query-parameters) for more details on this.
     * @param fields (optional) Explicitly defines which properties should be included in the response (by default all properties are included). Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api#query-parameters) for more details on this.
     * @param accept_Language (optional) Defines the language to return. Use this when querying language variant content items.
     * @param api_Key (optional) API key specified through configuration to authorize access to the API.
     * @param preview (optional) Whether to request draft content.
     * @param start_Item (optional) URL segment or GUID of a root content item.
     * @return OK
     */
    getContentItems2_0(id?: string[] | undefined, expand?: string | undefined, fields?: string | undefined, accept_Language?: string | undefined, api_Key?: string | undefined, preview?: boolean | undefined, start_Item?: string | undefined): Promise<IApiContentResponseModel[]>;
    /**
     * @param fetch (optional) Specifies the media items to fetch. Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api/media-delivery-api#query-parameters) for more details on this.
     * @param filter (optional) Defines how to filter the fetched media items. Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api/media-delivery-api#query-parameters) for more details on this.
     * @param sort (optional) Defines how to sort the found media items. Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api/media-delivery-api#query-parameters) for more details on this.
     * @param skip (optional) Specifies the number of found media items to skip. Use this to control pagination of the response.
     * @param take (optional) Specifies the number of found media items to take. Use this to control pagination of the response.
     * @param expand (optional) Defines the properties that should be expanded in the response. Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api/media-delivery-api#query-parameters) for more details on this.
     * @param api_Key (optional) API key specified through configuration to authorize access to the API.
     * @return OK
     * @deprecated
     */
    getMedia(fetch?: string | undefined, filter?: string[] | undefined, sort?: string[] | undefined, skip?: number | undefined, take?: number | undefined, expand?: string | undefined, api_Key?: string | undefined): Promise<PagedIApiMediaWithCropsResponseModel>;
    /**
     * @param fetch (optional) Specifies the media items to fetch. Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api/media-delivery-api#query-parameters) for more details on this.
     * @param filter (optional) Defines how to filter the fetched media items. Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api/media-delivery-api#query-parameters) for more details on this.
     * @param sort (optional) Defines how to sort the found media items. Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api/media-delivery-api#query-parameters) for more details on this.
     * @param skip (optional) Specifies the number of found media items to skip. Use this to control pagination of the response.
     * @param take (optional) Specifies the number of found media items to take. Use this to control pagination of the response.
     * @param expand (optional) Defines the properties that should be expanded in the response. Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api/media-delivery-api#query-parameters) for more details on this.
     * @param fields (optional) Explicitly defines which properties should be included in the response (by default all properties are included). Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api/media-delivery-api#query-parameters) for more details on this.
     * @param api_Key (optional) API key specified through configuration to authorize access to the API.
     * @return OK
     */
    getMedia2_0(fetch?: string | undefined, filter?: string[] | undefined, sort?: string[] | undefined, skip?: number | undefined, take?: number | undefined, expand?: string | undefined, fields?: string | undefined, api_Key?: string | undefined): Promise<PagedIApiMediaWithCropsResponseModel>;
    /**
     * @param id (optional) 
     * @param expand (optional) Defines the properties that should be expanded in the response. Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api/media-delivery-api#query-parameters) for more details on this.
     * @param api_Key (optional) API key specified through configuration to authorize access to the API.
     * @return OK
     * @deprecated
     */
    getMediaItem(id?: string[] | undefined, expand?: string | undefined, api_Key?: string | undefined): Promise<IApiMediaWithCropsResponseModel[]>;
    /**
     * @param expand (optional) Defines the properties that should be expanded in the response. Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api/media-delivery-api#query-parameters) for more details on this.
     * @param api_Key (optional) API key specified through configuration to authorize access to the API.
     * @return OK
     * @deprecated
     */
    getMediaItemByPath(path: string, expand?: string | undefined, api_Key?: string | undefined): Promise<IApiMediaWithCropsResponseModel>;
    /**
     * @param expand (optional) Defines the properties that should be expanded in the response. Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api/media-delivery-api#query-parameters) for more details on this.
     * @param fields (optional) Explicitly defines which properties should be included in the response (by default all properties are included). Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api/media-delivery-api#query-parameters) for more details on this.
     * @param api_Key (optional) API key specified through configuration to authorize access to the API.
     * @return OK
     */
    getMediaItemByPath2_0(path: string, expand?: string | undefined, fields?: string | undefined, api_Key?: string | undefined): Promise<IApiMediaWithCropsResponseModel>;
    /**
     * @param expand (optional) Defines the properties that should be expanded in the response. Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api/media-delivery-api#query-parameters) for more details on this.
     * @param api_Key (optional) API key specified through configuration to authorize access to the API.
     * @return OK
     * @deprecated
     */
    getMediaItemById(id: string, expand?: string | undefined, api_Key?: string | undefined): Promise<IApiMediaWithCropsResponseModel>;
    /**
     * @param expand (optional) Defines the properties that should be expanded in the response. Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api/media-delivery-api#query-parameters) for more details on this.
     * @param fields (optional) Explicitly defines which properties should be included in the response (by default all properties are included). Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api/media-delivery-api#query-parameters) for more details on this.
     * @param api_Key (optional) API key specified through configuration to authorize access to the API.
     * @return OK
     */
    getMediaItemById2_0(id: string, expand?: string | undefined, fields?: string | undefined, api_Key?: string | undefined): Promise<IApiMediaWithCropsResponseModel>;
    /**
     * @param id (optional) 
     * @param expand (optional) Defines the properties that should be expanded in the response. Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api/media-delivery-api#query-parameters) for more details on this.
     * @param fields (optional) Explicitly defines which properties should be included in the response (by default all properties are included). Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api/media-delivery-api#query-parameters) for more details on this.
     * @param api_Key (optional) API key specified through configuration to authorize access to the API.
     * @return OK
     */
    getMediaItems2_0(id?: string[] | undefined, expand?: string | undefined, fields?: string | undefined, api_Key?: string | undefined): Promise<IApiMediaWithCropsResponseModel[]>;
}

export class DeliveryApiClient extends BaseClient implements IDeliveryApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param fetch (optional) Specifies the content items to fetch. Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api#query-parameters) for more details on this.
     * @param filter (optional) Defines how to filter the fetched content items. Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api#query-parameters) for more details on this.
     * @param sort (optional) Defines how to sort the found content items. Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api#query-parameters) for more details on this.
     * @param skip (optional) Specifies the number of found content items to skip. Use this to control pagination of the response.
     * @param take (optional) Specifies the number of found content items to take. Use this to control pagination of the response.
     * @param expand (optional) Defines the properties that should be expanded in the response. Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api#query-parameters) for more details on this.
     * @param accept_Language (optional) Defines the language to return. Use this when querying language variant content items.
     * @param api_Key (optional) API key specified through configuration to authorize access to the API.
     * @param preview (optional) Whether to request draft content.
     * @param start_Item (optional) URL segment or GUID of a root content item.
     * @return OK
     * @deprecated
     */
    getContent(fetch?: string | undefined, filter?: string[] | undefined, sort?: string[] | undefined, skip?: number | undefined, take?: number | undefined, expand?: string | undefined, accept_Language?: string | undefined, api_Key?: string | undefined, preview?: boolean | undefined, start_Item?: string | undefined, signal?: AbortSignal): Promise<PagedIApiContentResponseModel> {
        let url_ = this.baseUrl + "/umbraco/delivery/api/v1/content?";
        if (fetch === null)
            throw new Error("The parameter 'fetch' cannot be null.");
        else if (fetch !== undefined)
            url_ += "fetch=" + encodeURIComponent("" + fetch) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            filter && filter.forEach(item => { url_ += "filter=" + encodeURIComponent("" + item) + "&"; });
        if (sort === null)
            throw new Error("The parameter 'sort' cannot be null.");
        else if (sort !== undefined)
            sort && sort.forEach(item => { url_ += "sort=" + encodeURIComponent("" + item) + "&"; });
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept-Language": accept_Language !== undefined && accept_Language !== null ? "" + accept_Language : "",
                "Api-Key": api_Key !== undefined && api_Key !== null ? "" + api_Key : "",
                "Preview": preview !== undefined && preview !== null ? "" + preview : "",
                "Start-Item": start_Item !== undefined && start_Item !== null ? "" + start_Item : "",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetContent(_response);
        });
    }

    protected processGetContent(response: AxiosResponse): Promise<PagedIApiContentResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedIApiContentResponseModel.fromJS(resultData200);
            return Promise.resolve<PagedIApiContentResponseModel>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedIApiContentResponseModel>(null as any);
    }

    /**
     * @param fetch (optional) Specifies the content items to fetch. Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api#query-parameters) for more details on this.
     * @param filter (optional) Defines how to filter the fetched content items. Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api#query-parameters) for more details on this.
     * @param sort (optional) Defines how to sort the found content items. Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api#query-parameters) for more details on this.
     * @param skip (optional) Specifies the number of found content items to skip. Use this to control pagination of the response.
     * @param take (optional) Specifies the number of found content items to take. Use this to control pagination of the response.
     * @param expand (optional) Defines the properties that should be expanded in the response. Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api#query-parameters) for more details on this.
     * @param fields (optional) Explicitly defines which properties should be included in the response (by default all properties are included). Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api#query-parameters) for more details on this.
     * @param accept_Language (optional) Defines the language to return. Use this when querying language variant content items.
     * @param api_Key (optional) API key specified through configuration to authorize access to the API.
     * @param preview (optional) Whether to request draft content.
     * @param start_Item (optional) URL segment or GUID of a root content item.
     * @return OK
     */
    getContent2_0(fetch?: string | undefined, filter?: string[] | undefined, sort?: string[] | undefined, skip?: number | undefined, take?: number | undefined, expand?: string | undefined, fields?: string | undefined, accept_Language?: string | undefined, api_Key?: string | undefined, preview?: boolean | undefined, start_Item?: string | undefined, signal?: AbortSignal): Promise<PagedIApiContentResponseModel> {
        let url_ = this.baseUrl + "/umbraco/delivery/api/v2/content?";
        if (fetch === null)
            throw new Error("The parameter 'fetch' cannot be null.");
        else if (fetch !== undefined)
            url_ += "fetch=" + encodeURIComponent("" + fetch) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            filter && filter.forEach(item => { url_ += "filter=" + encodeURIComponent("" + item) + "&"; });
        if (sort === null)
            throw new Error("The parameter 'sort' cannot be null.");
        else if (sort !== undefined)
            sort && sort.forEach(item => { url_ += "sort=" + encodeURIComponent("" + item) + "&"; });
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "expand=" + encodeURIComponent("" + expand) + "&";
        if (fields === null)
            throw new Error("The parameter 'fields' cannot be null.");
        else if (fields !== undefined)
            url_ += "fields=" + encodeURIComponent("" + fields) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept-Language": accept_Language !== undefined && accept_Language !== null ? "" + accept_Language : "",
                "Api-Key": api_Key !== undefined && api_Key !== null ? "" + api_Key : "",
                "Preview": preview !== undefined && preview !== null ? "" + preview : "",
                "Start-Item": start_Item !== undefined && start_Item !== null ? "" + start_Item : "",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetContent2_0(_response);
        });
    }

    protected processGetContent2_0(response: AxiosResponse): Promise<PagedIApiContentResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedIApiContentResponseModel.fromJS(resultData200);
            return Promise.resolve<PagedIApiContentResponseModel>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedIApiContentResponseModel>(null as any);
    }

    /**
     * @param id (optional) 
     * @param expand (optional) Defines the properties that should be expanded in the response. Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api#query-parameters) for more details on this.
     * @param accept_Language (optional) Defines the language to return. Use this when querying language variant content items.
     * @param api_Key (optional) API key specified through configuration to authorize access to the API.
     * @param preview (optional) Whether to request draft content.
     * @param start_Item (optional) URL segment or GUID of a root content item.
     * @return OK
     * @deprecated
     */
    getContentItem(id?: string[] | undefined, expand?: string | undefined, accept_Language?: string | undefined, api_Key?: string | undefined, preview?: boolean | undefined, start_Item?: string | undefined, signal?: AbortSignal): Promise<IApiContentResponseModel[]> {
        let url_ = this.baseUrl + "/umbraco/delivery/api/v1/content/item?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            id && id.forEach(item => { url_ += "id=" + encodeURIComponent("" + item) + "&"; });
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept-Language": accept_Language !== undefined && accept_Language !== null ? "" + accept_Language : "",
                "Api-Key": api_Key !== undefined && api_Key !== null ? "" + api_Key : "",
                "Preview": preview !== undefined && preview !== null ? "" + preview : "",
                "Start-Item": start_Item !== undefined && start_Item !== null ? "" + start_Item : "",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetContentItem(_response);
        });
    }

    protected processGetContentItem(response: AxiosResponse): Promise<IApiContentResponseModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IApiContentResponseModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<IApiContentResponseModel[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IApiContentResponseModel[]>(null as any);
    }

    /**
     * @param expand (optional) Defines the properties that should be expanded in the response. Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api#query-parameters) for more details on this.
     * @param accept_Language (optional) Defines the language to return. Use this when querying language variant content items.
     * @param api_Key (optional) API key specified through configuration to authorize access to the API.
     * @param preview (optional) Whether to request draft content.
     * @param start_Item (optional) URL segment or GUID of a root content item.
     * @return OK
     * @deprecated
     */
    getContentItemByPath(path: string, expand?: string | undefined, accept_Language?: string | undefined, api_Key?: string | undefined, preview?: boolean | undefined, start_Item?: string | undefined, signal?: AbortSignal): Promise<IApiContentResponseModel> {
        let url_ = this.baseUrl + "/umbraco/delivery/api/v1/content/item/{path}?";
        if (path === undefined || path === null)
            throw new Error("The parameter 'path' must be defined.");
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept-Language": accept_Language !== undefined && accept_Language !== null ? "" + accept_Language : "",
                "Api-Key": api_Key !== undefined && api_Key !== null ? "" + api_Key : "",
                "Preview": preview !== undefined && preview !== null ? "" + preview : "",
                "Start-Item": start_Item !== undefined && start_Item !== null ? "" + start_Item : "",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetContentItemByPath(_response);
        });
    }

    protected processGetContentItemByPath(response: AxiosResponse): Promise<IApiContentResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IApiContentResponseModel.fromJS(resultData200);
            return Promise.resolve<IApiContentResponseModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IApiContentResponseModel>(null as any);
    }

    /**
     * @param expand (optional) Defines the properties that should be expanded in the response. Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api#query-parameters) for more details on this.
     * @param fields (optional) Explicitly defines which properties should be included in the response (by default all properties are included). Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api#query-parameters) for more details on this.
     * @param accept_Language (optional) Defines the language to return. Use this when querying language variant content items.
     * @param api_Key (optional) API key specified through configuration to authorize access to the API.
     * @param preview (optional) Whether to request draft content.
     * @param start_Item (optional) URL segment or GUID of a root content item.
     * @return OK
     */
    getContentItemByPath2_0(path: string, expand?: string | undefined, fields?: string | undefined, accept_Language?: string | undefined, api_Key?: string | undefined, preview?: boolean | undefined, start_Item?: string | undefined, signal?: AbortSignal): Promise<IApiContentResponseModel> {
        let url_ = this.baseUrl + "/umbraco/delivery/api/v2/content/item/{path}?";
        if (path === undefined || path === null)
            throw new Error("The parameter 'path' must be defined.");
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "expand=" + encodeURIComponent("" + expand) + "&";
        if (fields === null)
            throw new Error("The parameter 'fields' cannot be null.");
        else if (fields !== undefined)
            url_ += "fields=" + encodeURIComponent("" + fields) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept-Language": accept_Language !== undefined && accept_Language !== null ? "" + accept_Language : "",
                "Api-Key": api_Key !== undefined && api_Key !== null ? "" + api_Key : "",
                "Preview": preview !== undefined && preview !== null ? "" + preview : "",
                "Start-Item": start_Item !== undefined && start_Item !== null ? "" + start_Item : "",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetContentItemByPath2_0(_response);
        });
    }

    protected processGetContentItemByPath2_0(response: AxiosResponse): Promise<IApiContentResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IApiContentResponseModel.fromJS(resultData200);
            return Promise.resolve<IApiContentResponseModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IApiContentResponseModel>(null as any);
    }

    /**
     * @param expand (optional) Defines the properties that should be expanded in the response. Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api#query-parameters) for more details on this.
     * @param accept_Language (optional) Defines the language to return. Use this when querying language variant content items.
     * @param api_Key (optional) API key specified through configuration to authorize access to the API.
     * @param preview (optional) Whether to request draft content.
     * @param start_Item (optional) URL segment or GUID of a root content item.
     * @return OK
     * @deprecated
     */
    getContentItemById(id: string, expand?: string | undefined, accept_Language?: string | undefined, api_Key?: string | undefined, preview?: boolean | undefined, start_Item?: string | undefined, signal?: AbortSignal): Promise<IApiContentResponseModel> {
        let url_ = this.baseUrl + "/umbraco/delivery/api/v1/content/item/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept-Language": accept_Language !== undefined && accept_Language !== null ? "" + accept_Language : "",
                "Api-Key": api_Key !== undefined && api_Key !== null ? "" + api_Key : "",
                "Preview": preview !== undefined && preview !== null ? "" + preview : "",
                "Start-Item": start_Item !== undefined && start_Item !== null ? "" + start_Item : "",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetContentItemById(_response);
        });
    }

    protected processGetContentItemById(response: AxiosResponse): Promise<IApiContentResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IApiContentResponseModel.fromJS(resultData200);
            return Promise.resolve<IApiContentResponseModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IApiContentResponseModel>(null as any);
    }

    /**
     * @param expand (optional) Defines the properties that should be expanded in the response. Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api#query-parameters) for more details on this.
     * @param fields (optional) Explicitly defines which properties should be included in the response (by default all properties are included). Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api#query-parameters) for more details on this.
     * @param accept_Language (optional) Defines the language to return. Use this when querying language variant content items.
     * @param api_Key (optional) API key specified through configuration to authorize access to the API.
     * @param preview (optional) Whether to request draft content.
     * @param start_Item (optional) URL segment or GUID of a root content item.
     * @return OK
     */
    getContentItemById2_0(id: string, expand?: string | undefined, fields?: string | undefined, accept_Language?: string | undefined, api_Key?: string | undefined, preview?: boolean | undefined, start_Item?: string | undefined, signal?: AbortSignal): Promise<IApiContentResponseModel> {
        let url_ = this.baseUrl + "/umbraco/delivery/api/v2/content/item/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "expand=" + encodeURIComponent("" + expand) + "&";
        if (fields === null)
            throw new Error("The parameter 'fields' cannot be null.");
        else if (fields !== undefined)
            url_ += "fields=" + encodeURIComponent("" + fields) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept-Language": accept_Language !== undefined && accept_Language !== null ? "" + accept_Language : "",
                "Api-Key": api_Key !== undefined && api_Key !== null ? "" + api_Key : "",
                "Preview": preview !== undefined && preview !== null ? "" + preview : "",
                "Start-Item": start_Item !== undefined && start_Item !== null ? "" + start_Item : "",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetContentItemById2_0(_response);
        });
    }

    protected processGetContentItemById2_0(response: AxiosResponse): Promise<IApiContentResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IApiContentResponseModel.fromJS(resultData200);
            return Promise.resolve<IApiContentResponseModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IApiContentResponseModel>(null as any);
    }

    /**
     * @param id (optional) 
     * @param expand (optional) Defines the properties that should be expanded in the response. Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api#query-parameters) for more details on this.
     * @param fields (optional) Explicitly defines which properties should be included in the response (by default all properties are included). Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api#query-parameters) for more details on this.
     * @param accept_Language (optional) Defines the language to return. Use this when querying language variant content items.
     * @param api_Key (optional) API key specified through configuration to authorize access to the API.
     * @param preview (optional) Whether to request draft content.
     * @param start_Item (optional) URL segment or GUID of a root content item.
     * @return OK
     */
    getContentItems2_0(id?: string[] | undefined, expand?: string | undefined, fields?: string | undefined, accept_Language?: string | undefined, api_Key?: string | undefined, preview?: boolean | undefined, start_Item?: string | undefined, signal?: AbortSignal): Promise<IApiContentResponseModel[]> {
        let url_ = this.baseUrl + "/umbraco/delivery/api/v2/content/items?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            id && id.forEach(item => { url_ += "id=" + encodeURIComponent("" + item) + "&"; });
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "expand=" + encodeURIComponent("" + expand) + "&";
        if (fields === null)
            throw new Error("The parameter 'fields' cannot be null.");
        else if (fields !== undefined)
            url_ += "fields=" + encodeURIComponent("" + fields) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept-Language": accept_Language !== undefined && accept_Language !== null ? "" + accept_Language : "",
                "Api-Key": api_Key !== undefined && api_Key !== null ? "" + api_Key : "",
                "Preview": preview !== undefined && preview !== null ? "" + preview : "",
                "Start-Item": start_Item !== undefined && start_Item !== null ? "" + start_Item : "",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetContentItems2_0(_response);
        });
    }

    protected processGetContentItems2_0(response: AxiosResponse): Promise<IApiContentResponseModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IApiContentResponseModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<IApiContentResponseModel[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IApiContentResponseModel[]>(null as any);
    }

    /**
     * @param fetch (optional) Specifies the media items to fetch. Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api/media-delivery-api#query-parameters) for more details on this.
     * @param filter (optional) Defines how to filter the fetched media items. Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api/media-delivery-api#query-parameters) for more details on this.
     * @param sort (optional) Defines how to sort the found media items. Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api/media-delivery-api#query-parameters) for more details on this.
     * @param skip (optional) Specifies the number of found media items to skip. Use this to control pagination of the response.
     * @param take (optional) Specifies the number of found media items to take. Use this to control pagination of the response.
     * @param expand (optional) Defines the properties that should be expanded in the response. Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api/media-delivery-api#query-parameters) for more details on this.
     * @param api_Key (optional) API key specified through configuration to authorize access to the API.
     * @return OK
     * @deprecated
     */
    getMedia(fetch?: string | undefined, filter?: string[] | undefined, sort?: string[] | undefined, skip?: number | undefined, take?: number | undefined, expand?: string | undefined, api_Key?: string | undefined, signal?: AbortSignal): Promise<PagedIApiMediaWithCropsResponseModel> {
        let url_ = this.baseUrl + "/umbraco/delivery/api/v1/media?";
        if (fetch === null)
            throw new Error("The parameter 'fetch' cannot be null.");
        else if (fetch !== undefined)
            url_ += "fetch=" + encodeURIComponent("" + fetch) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            filter && filter.forEach(item => { url_ += "filter=" + encodeURIComponent("" + item) + "&"; });
        if (sort === null)
            throw new Error("The parameter 'sort' cannot be null.");
        else if (sort !== undefined)
            sort && sort.forEach(item => { url_ += "sort=" + encodeURIComponent("" + item) + "&"; });
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Api-Key": api_Key !== undefined && api_Key !== null ? "" + api_Key : "",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMedia(_response);
        });
    }

    protected processGetMedia(response: AxiosResponse): Promise<PagedIApiMediaWithCropsResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedIApiMediaWithCropsResponseModel.fromJS(resultData200);
            return Promise.resolve<PagedIApiMediaWithCropsResponseModel>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedIApiMediaWithCropsResponseModel>(null as any);
    }

    /**
     * @param fetch (optional) Specifies the media items to fetch. Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api/media-delivery-api#query-parameters) for more details on this.
     * @param filter (optional) Defines how to filter the fetched media items. Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api/media-delivery-api#query-parameters) for more details on this.
     * @param sort (optional) Defines how to sort the found media items. Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api/media-delivery-api#query-parameters) for more details on this.
     * @param skip (optional) Specifies the number of found media items to skip. Use this to control pagination of the response.
     * @param take (optional) Specifies the number of found media items to take. Use this to control pagination of the response.
     * @param expand (optional) Defines the properties that should be expanded in the response. Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api/media-delivery-api#query-parameters) for more details on this.
     * @param fields (optional) Explicitly defines which properties should be included in the response (by default all properties are included). Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api/media-delivery-api#query-parameters) for more details on this.
     * @param api_Key (optional) API key specified through configuration to authorize access to the API.
     * @return OK
     */
    getMedia2_0(fetch?: string | undefined, filter?: string[] | undefined, sort?: string[] | undefined, skip?: number | undefined, take?: number | undefined, expand?: string | undefined, fields?: string | undefined, api_Key?: string | undefined, signal?: AbortSignal): Promise<PagedIApiMediaWithCropsResponseModel> {
        let url_ = this.baseUrl + "/umbraco/delivery/api/v2/media?";
        if (fetch === null)
            throw new Error("The parameter 'fetch' cannot be null.");
        else if (fetch !== undefined)
            url_ += "fetch=" + encodeURIComponent("" + fetch) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            filter && filter.forEach(item => { url_ += "filter=" + encodeURIComponent("" + item) + "&"; });
        if (sort === null)
            throw new Error("The parameter 'sort' cannot be null.");
        else if (sort !== undefined)
            sort && sort.forEach(item => { url_ += "sort=" + encodeURIComponent("" + item) + "&"; });
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "expand=" + encodeURIComponent("" + expand) + "&";
        if (fields === null)
            throw new Error("The parameter 'fields' cannot be null.");
        else if (fields !== undefined)
            url_ += "fields=" + encodeURIComponent("" + fields) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Api-Key": api_Key !== undefined && api_Key !== null ? "" + api_Key : "",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMedia2_0(_response);
        });
    }

    protected processGetMedia2_0(response: AxiosResponse): Promise<PagedIApiMediaWithCropsResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedIApiMediaWithCropsResponseModel.fromJS(resultData200);
            return Promise.resolve<PagedIApiMediaWithCropsResponseModel>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedIApiMediaWithCropsResponseModel>(null as any);
    }

    /**
     * @param id (optional) 
     * @param expand (optional) Defines the properties that should be expanded in the response. Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api/media-delivery-api#query-parameters) for more details on this.
     * @param api_Key (optional) API key specified through configuration to authorize access to the API.
     * @return OK
     * @deprecated
     */
    getMediaItem(id?: string[] | undefined, expand?: string | undefined, api_Key?: string | undefined, signal?: AbortSignal): Promise<IApiMediaWithCropsResponseModel[]> {
        let url_ = this.baseUrl + "/umbraco/delivery/api/v1/media/item?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            id && id.forEach(item => { url_ += "id=" + encodeURIComponent("" + item) + "&"; });
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Api-Key": api_Key !== undefined && api_Key !== null ? "" + api_Key : "",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMediaItem(_response);
        });
    }

    protected processGetMediaItem(response: AxiosResponse): Promise<IApiMediaWithCropsResponseModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IApiMediaWithCropsResponseModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<IApiMediaWithCropsResponseModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IApiMediaWithCropsResponseModel[]>(null as any);
    }

    /**
     * @param expand (optional) Defines the properties that should be expanded in the response. Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api/media-delivery-api#query-parameters) for more details on this.
     * @param api_Key (optional) API key specified through configuration to authorize access to the API.
     * @return OK
     * @deprecated
     */
    getMediaItemByPath(path: string, expand?: string | undefined, api_Key?: string | undefined, signal?: AbortSignal): Promise<IApiMediaWithCropsResponseModel> {
        let url_ = this.baseUrl + "/umbraco/delivery/api/v1/media/item/{path}?";
        if (path === undefined || path === null)
            throw new Error("The parameter 'path' must be defined.");
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Api-Key": api_Key !== undefined && api_Key !== null ? "" + api_Key : "",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMediaItemByPath(_response);
        });
    }

    protected processGetMediaItemByPath(response: AxiosResponse): Promise<IApiMediaWithCropsResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IApiMediaWithCropsResponseModel.fromJS(resultData200);
            return Promise.resolve<IApiMediaWithCropsResponseModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IApiMediaWithCropsResponseModel>(null as any);
    }

    /**
     * @param expand (optional) Defines the properties that should be expanded in the response. Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api/media-delivery-api#query-parameters) for more details on this.
     * @param fields (optional) Explicitly defines which properties should be included in the response (by default all properties are included). Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api/media-delivery-api#query-parameters) for more details on this.
     * @param api_Key (optional) API key specified through configuration to authorize access to the API.
     * @return OK
     */
    getMediaItemByPath2_0(path: string, expand?: string | undefined, fields?: string | undefined, api_Key?: string | undefined, signal?: AbortSignal): Promise<IApiMediaWithCropsResponseModel> {
        let url_ = this.baseUrl + "/umbraco/delivery/api/v2/media/item/{path}?";
        if (path === undefined || path === null)
            throw new Error("The parameter 'path' must be defined.");
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "expand=" + encodeURIComponent("" + expand) + "&";
        if (fields === null)
            throw new Error("The parameter 'fields' cannot be null.");
        else if (fields !== undefined)
            url_ += "fields=" + encodeURIComponent("" + fields) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Api-Key": api_Key !== undefined && api_Key !== null ? "" + api_Key : "",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMediaItemByPath2_0(_response);
        });
    }

    protected processGetMediaItemByPath2_0(response: AxiosResponse): Promise<IApiMediaWithCropsResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IApiMediaWithCropsResponseModel.fromJS(resultData200);
            return Promise.resolve<IApiMediaWithCropsResponseModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IApiMediaWithCropsResponseModel>(null as any);
    }

    /**
     * @param expand (optional) Defines the properties that should be expanded in the response. Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api/media-delivery-api#query-parameters) for more details on this.
     * @param api_Key (optional) API key specified through configuration to authorize access to the API.
     * @return OK
     * @deprecated
     */
    getMediaItemById(id: string, expand?: string | undefined, api_Key?: string | undefined, signal?: AbortSignal): Promise<IApiMediaWithCropsResponseModel> {
        let url_ = this.baseUrl + "/umbraco/delivery/api/v1/media/item/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Api-Key": api_Key !== undefined && api_Key !== null ? "" + api_Key : "",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMediaItemById(_response);
        });
    }

    protected processGetMediaItemById(response: AxiosResponse): Promise<IApiMediaWithCropsResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IApiMediaWithCropsResponseModel.fromJS(resultData200);
            return Promise.resolve<IApiMediaWithCropsResponseModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IApiMediaWithCropsResponseModel>(null as any);
    }

    /**
     * @param expand (optional) Defines the properties that should be expanded in the response. Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api/media-delivery-api#query-parameters) for more details on this.
     * @param fields (optional) Explicitly defines which properties should be included in the response (by default all properties are included). Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api/media-delivery-api#query-parameters) for more details on this.
     * @param api_Key (optional) API key specified through configuration to authorize access to the API.
     * @return OK
     */
    getMediaItemById2_0(id: string, expand?: string | undefined, fields?: string | undefined, api_Key?: string | undefined, signal?: AbortSignal): Promise<IApiMediaWithCropsResponseModel> {
        let url_ = this.baseUrl + "/umbraco/delivery/api/v2/media/item/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "expand=" + encodeURIComponent("" + expand) + "&";
        if (fields === null)
            throw new Error("The parameter 'fields' cannot be null.");
        else if (fields !== undefined)
            url_ += "fields=" + encodeURIComponent("" + fields) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Api-Key": api_Key !== undefined && api_Key !== null ? "" + api_Key : "",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMediaItemById2_0(_response);
        });
    }

    protected processGetMediaItemById2_0(response: AxiosResponse): Promise<IApiMediaWithCropsResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IApiMediaWithCropsResponseModel.fromJS(resultData200);
            return Promise.resolve<IApiMediaWithCropsResponseModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IApiMediaWithCropsResponseModel>(null as any);
    }

    /**
     * @param id (optional) 
     * @param expand (optional) Defines the properties that should be expanded in the response. Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api/media-delivery-api#query-parameters) for more details on this.
     * @param fields (optional) Explicitly defines which properties should be included in the response (by default all properties are included). Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api/media-delivery-api#query-parameters) for more details on this.
     * @param api_Key (optional) API key specified through configuration to authorize access to the API.
     * @return OK
     */
    getMediaItems2_0(id?: string[] | undefined, expand?: string | undefined, fields?: string | undefined, api_Key?: string | undefined, signal?: AbortSignal): Promise<IApiMediaWithCropsResponseModel[]> {
        let url_ = this.baseUrl + "/umbraco/delivery/api/v2/media/items?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            id && id.forEach(item => { url_ += "id=" + encodeURIComponent("" + item) + "&"; });
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "expand=" + encodeURIComponent("" + expand) + "&";
        if (fields === null)
            throw new Error("The parameter 'fields' cannot be null.");
        else if (fields !== undefined)
            url_ += "fields=" + encodeURIComponent("" + fields) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Api-Key": api_Key !== undefined && api_Key !== null ? "" + api_Key : "",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMediaItems2_0(_response);
        });
    }

    protected processGetMediaItems2_0(response: AxiosResponse): Promise<IApiMediaWithCropsResponseModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IApiMediaWithCropsResponseModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<IApiMediaWithCropsResponseModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IApiMediaWithCropsResponseModel[]>(null as any);
    }
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export class HttpValidationProblemDetails extends ProblemDetails implements IHttpValidationProblemDetails {
    errors?: { [key: string]: string[]; };

    [key: string]: any;

    constructor(data?: IHttpValidationProblemDetails) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (<any>this.errors)![key] = _data["errors"][key] !== undefined ? _data["errors"][key] : [];
                }
            }
        }
    }

    static override fromJS(data: any): HttpValidationProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new HttpValidationProblemDetails();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (<any>data["errors"])[key] = (<any>this.errors)[key];
            }
        }
        super.toJSON(data);
        return data;
    }
}

export interface IHttpValidationProblemDetails extends IProblemDetails {
    errors?: { [key: string]: string[]; };

    [key: string]: any;
}

export class IApiContentResponseModel implements IIApiContentResponseModel {
    readonly id?: string;
    readonly contentType?: string;
    readonly properties?: { [key: string]: any; };
    readonly name?: string | undefined;
    readonly createDate?: Date;
    readonly updateDate?: Date;
    route?: IApiContentRouteModel;
    readonly cultures?: { [key: string]: IApiContentRouteModel; };

    constructor(data?: IIApiContentResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).id = _data["id"];
            (<any>this).contentType = _data["contentType"];
            if (_data["properties"]) {
                (<any>this).properties = {} as any;
                for (let key in _data["properties"]) {
                    if (_data["properties"].hasOwnProperty(key))
                        (<any>(<any>this).properties)![key] = _data["properties"][key];
                }
            }
            (<any>this).name = _data["name"];
            (<any>this).createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : <any>undefined;
            (<any>this).updateDate = _data["updateDate"] ? new Date(_data["updateDate"].toString()) : <any>undefined;
            this.route = _data["route"] ? IApiContentRouteModel.fromJS(_data["route"]) : <any>undefined;
            if (_data["cultures"]) {
                (<any>this).cultures = {} as any;
                for (let key in _data["cultures"]) {
                    if (_data["cultures"].hasOwnProperty(key))
                        (<any>(<any>this).cultures)![key] = _data["cultures"][key] ? IApiContentRouteModel.fromJS(_data["cultures"][key]) : new IApiContentRouteModel();
                }
            }
        }
    }

    static fromJS(data: any): IApiContentResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new IApiContentResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["contentType"] = this.contentType;
        if (this.properties) {
            data["properties"] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    (<any>data["properties"])[key] = (<any>this.properties)[key];
            }
        }
        data["name"] = this.name;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data["updateDate"] = this.updateDate ? this.updateDate.toISOString() : <any>undefined;
        data["route"] = this.route ? this.route.toJSON() : <any>undefined;
        if (this.cultures) {
            data["cultures"] = {};
            for (let key in this.cultures) {
                if (this.cultures.hasOwnProperty(key))
                    (<any>data["cultures"])[key] = this.cultures[key] ? this.cultures[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }
}

export interface IIApiContentResponseModel {
    id?: string;
    contentType?: string;
    properties?: { [key: string]: any; };
    name?: string | undefined;
    createDate?: Date;
    updateDate?: Date;
    route?: IApiContentRouteModel;
    cultures?: { [key: string]: IApiContentRouteModel; };
}

export class IApiContentRouteModel implements IIApiContentRouteModel {
    readonly path?: string;
    startItem?: IApiContentStartItemModel;

    constructor(data?: IIApiContentRouteModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).path = _data["path"];
            this.startItem = _data["startItem"] ? IApiContentStartItemModel.fromJS(_data["startItem"]) : <any>undefined;
        }
    }

    static fromJS(data: any): IApiContentRouteModel {
        data = typeof data === 'object' ? data : {};
        let result = new IApiContentRouteModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["path"] = this.path;
        data["startItem"] = this.startItem ? this.startItem.toJSON() : <any>undefined;
        return data;
    }
}

export interface IIApiContentRouteModel {
    path?: string;
    startItem?: IApiContentStartItemModel;
}

export class IApiContentStartItemModel implements IIApiContentStartItemModel {
    readonly id?: string;
    readonly path?: string;

    constructor(data?: IIApiContentStartItemModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).id = _data["id"];
            (<any>this).path = _data["path"];
        }
    }

    static fromJS(data: any): IApiContentStartItemModel {
        data = typeof data === 'object' ? data : {};
        let result = new IApiContentStartItemModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["path"] = this.path;
        return data;
    }
}

export interface IIApiContentStartItemModel {
    id?: string;
    path?: string;
}

export class IApiMediaWithCropsResponseModel implements IIApiMediaWithCropsResponseModel {
    readonly id?: string;
    readonly name?: string;
    readonly mediaType?: string;
    readonly url?: string;
    readonly extension?: string | undefined;
    readonly width?: number | undefined;
    readonly height?: number | undefined;
    readonly bytes?: number | undefined;
    readonly properties?: { [key: string]: any; };
    focalPoint?: ImageFocalPointModel;
    readonly crops?: ImageCropModel[] | undefined;
    readonly path?: string;
    readonly createDate?: Date;
    readonly updateDate?: Date;

    constructor(data?: IIApiMediaWithCropsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).id = _data["id"];
            (<any>this).name = _data["name"];
            (<any>this).mediaType = _data["mediaType"];
            (<any>this).url = _data["url"];
            (<any>this).extension = _data["extension"];
            (<any>this).width = _data["width"];
            (<any>this).height = _data["height"];
            (<any>this).bytes = _data["bytes"];
            if (_data["properties"]) {
                (<any>this).properties = {} as any;
                for (let key in _data["properties"]) {
                    if (_data["properties"].hasOwnProperty(key))
                        (<any>(<any>this).properties)![key] = _data["properties"][key];
                }
            }
            this.focalPoint = _data["focalPoint"] ? ImageFocalPointModel.fromJS(_data["focalPoint"]) : <any>undefined;
            if (Array.isArray(_data["crops"])) {
                (<any>this).crops = [] as any;
                for (let item of _data["crops"])
                    (<any>this).crops!.push(ImageCropModel.fromJS(item));
            }
            (<any>this).path = _data["path"];
            (<any>this).createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : <any>undefined;
            (<any>this).updateDate = _data["updateDate"] ? new Date(_data["updateDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): IApiMediaWithCropsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new IApiMediaWithCropsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["mediaType"] = this.mediaType;
        data["url"] = this.url;
        data["extension"] = this.extension;
        data["width"] = this.width;
        data["height"] = this.height;
        data["bytes"] = this.bytes;
        if (this.properties) {
            data["properties"] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    (<any>data["properties"])[key] = (<any>this.properties)[key];
            }
        }
        data["focalPoint"] = this.focalPoint ? this.focalPoint.toJSON() : <any>undefined;
        if (Array.isArray(this.crops)) {
            data["crops"] = [];
            for (let item of this.crops)
                data["crops"].push(item.toJSON());
        }
        data["path"] = this.path;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data["updateDate"] = this.updateDate ? this.updateDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IIApiMediaWithCropsResponseModel {
    id?: string;
    name?: string;
    mediaType?: string;
    url?: string;
    extension?: string | undefined;
    width?: number | undefined;
    height?: number | undefined;
    bytes?: number | undefined;
    properties?: { [key: string]: any; };
    focalPoint?: ImageFocalPointModel;
    crops?: ImageCropModel[] | undefined;
    path?: string;
    createDate?: Date;
    updateDate?: Date;
}

export class ImageCropCoordinatesModel implements IImageCropCoordinatesModel {
    x1?: number;
    y1?: number;
    x2?: number;
    y2?: number;

    constructor(data?: IImageCropCoordinatesModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.x1 = _data["x1"];
            this.y1 = _data["y1"];
            this.x2 = _data["x2"];
            this.y2 = _data["y2"];
        }
    }

    static fromJS(data: any): ImageCropCoordinatesModel {
        data = typeof data === 'object' ? data : {};
        let result = new ImageCropCoordinatesModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["x1"] = this.x1;
        data["y1"] = this.y1;
        data["x2"] = this.x2;
        data["y2"] = this.y2;
        return data;
    }
}

export interface IImageCropCoordinatesModel {
    x1?: number;
    y1?: number;
    x2?: number;
    y2?: number;
}

export class ImageCropModel implements IImageCropModel {
    alias?: string | undefined;
    width?: number;
    height?: number;
    coordinates?: ImageCropCoordinatesModel;

    constructor(data?: IImageCropModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alias = _data["alias"];
            this.width = _data["width"];
            this.height = _data["height"];
            this.coordinates = _data["coordinates"] ? ImageCropCoordinatesModel.fromJS(_data["coordinates"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ImageCropModel {
        data = typeof data === 'object' ? data : {};
        let result = new ImageCropModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alias"] = this.alias;
        data["width"] = this.width;
        data["height"] = this.height;
        data["coordinates"] = this.coordinates ? this.coordinates.toJSON() : <any>undefined;
        return data;
    }
}

export interface IImageCropModel {
    alias?: string | undefined;
    width?: number;
    height?: number;
    coordinates?: ImageCropCoordinatesModel;
}

export class ImageFocalPointModel implements IImageFocalPointModel {
    left?: number;
    top?: number;

    constructor(data?: IImageFocalPointModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.left = _data["left"];
            this.top = _data["top"];
        }
    }

    static fromJS(data: any): ImageFocalPointModel {
        data = typeof data === 'object' ? data : {};
        let result = new ImageFocalPointModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["left"] = this.left;
        data["top"] = this.top;
        return data;
    }
}

export interface IImageFocalPointModel {
    left?: number;
    top?: number;
}

export class PagedIApiContentResponseModel implements IPagedIApiContentResponseModel {
    total!: number;
    items!: IApiContentResponseModel[];

    constructor(data?: IPagedIApiContentResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(IApiContentResponseModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedIApiContentResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new PagedIApiContentResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedIApiContentResponseModel {
    total: number;
    items: IApiContentResponseModel[];
}

export class PagedIApiMediaWithCropsResponseModel implements IPagedIApiMediaWithCropsResponseModel {
    total!: number;
    items!: IApiMediaWithCropsResponseModel[];

    constructor(data?: IPagedIApiMediaWithCropsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(IApiMediaWithCropsResponseModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedIApiMediaWithCropsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new PagedIApiMediaWithCropsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedIApiMediaWithCropsResponseModel {
    total: number;
    items: IApiMediaWithCropsResponseModel[];
}

export class DeliveryApiClientException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isDeliveryApiClientException = true;

    static isDeliveryApiClientException(obj: any): obj is DeliveryApiClientException {
        return obj.isDeliveryApiClientException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new DeliveryApiClientException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}